import { useCallback, useState } from "react";

type Tick = Record<string, never>;
type Tock = () => void;

export function useTicker(): [Tick, Tock] {
    const [tick, tock] = useState<Tick>({});
    return [tick, useCallback(() => tock({}), [tock])];
}
